/**
 * Outbox View Tracker
 * - On product pages: pings the worker to record a view
 * - On collection pages: reorders the grid when "Best Selling" is active, by priority:
 *     1. Products with real sales — kept in Shopify's own best-selling order
 *     2. New products (< newDays old, default 7) — newest first
 *     3. Everything else — by view count, descending
 *   Sales counts come from the worker (seeded from order history + live orders/create webhook).
 *
 * Requires window.outboxViewTracker to be set before this script runs (done in theme.liquid).
 */
(function () {
  'use strict';

  var config = window.outboxViewTracker;
  if (!config || !config.workerUrl || config.workerUrl.indexOf('REPLACE') !== -1) return;

  var WORKER_URL = config.workerUrl.replace(/\/$/, '');
  var NEW_DAYS = config.newDays || 7;

  // ─── PRODUCT PAGE: fire-and-forget view tracking ──────────────────────────
  if (config.productId) {
    var payload = JSON.stringify({ productId: String(config.productId) });
    try {
      if (navigator.sendBeacon) {
        navigator.sendBeacon(
          WORKER_URL + '/track',
          new Blob([payload], { type: 'application/json' })
        );
      } else {
        fetch(WORKER_URL + '/track', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: payload,
          keepalive: true
        });
      }
    } catch (_) {}
    return; // nothing else to do on product pages
  }

  // ─── COLLECTION PAGE: reorder grid items ──────────────────────────────────
  var gridContainer = document.getElementById('ProductGridContainer');
  if (!gridContainer) return;

  function getCurrentSortBy() {
    return new URLSearchParams(window.location.search).get('sort_by') || '';
  }

  function isBestSellingActive() {
    // 1. Check URL param — most explicit signal
    var sort = getCurrentSortBy();
    if (sort === 'best-selling') return true;
    if (sort !== '') return false; // some other sort explicitly chosen

    // 2. No URL param — check the actual sort dropdown value (most reliable)
    var sortSelect = document.getElementById('SortBy') || document.getElementById('SortBy-mobile');
    if (sortSelect) return sortSelect.value === 'best-selling';

    // 3. No dropdown (sorting disabled on this collection) — fall back to data attribute
    var grid = document.getElementById('product-grid');
    if (!grid) return false;
    var defaultSort = grid.dataset.defaultSort || '';
    return defaultSort === 'best-selling' || defaultSort === 'best_selling' || defaultSort === '';
  }

  function reorderGrid() {
    var grid = document.getElementById('product-grid');
    if (!grid) return;

    var items = Array.from(grid.querySelectorAll('li[data-product-id]'));
    if (items.length < 2) return;

    var ids = items.map(function (li) { return li.dataset.productId; }).join(',');

    fetch(WORKER_URL + '/sorted?ids=' + encodeURIComponent(ids))
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (!data) return;

        // Legacy fallback: worker not yet updated with sales data → old views-only order
        if (!data.sales) {
          if (!data.sorted || !data.sorted.length) return;
          var idToEl = {};
          items.forEach(function (li) { idToEl[li.dataset.productId] = li; });
          data.sorted.forEach(function (id) {
            var el = idToEl[id];
            if (el) grid.appendChild(el);
          });
          return;
        }

        var counts = data.counts || {};
        var sales = data.sales || {};
        var nowSec = Math.floor(Date.now() / 1000);
        var newCutoff = nowSec - NEW_DAYS * 86400;

        var entries = items.map(function (li, index) {
          var id = li.dataset.productId;
          return {
            el: li,
            index: index, // Shopify's best-selling rank position
            views: Number(counts[id]) || 0,
            sold: Number(sales[id]) || 0,
            created: Number(li.dataset.created) || 0
          };
        });

        // 1. Real bestsellers — keep Shopify's own sales-ranked order
        var group1 = entries.filter(function (e) { return e.sold > 0; });

        // 2. New arrivals without sales — newest first
        var group2 = entries.filter(function (e) { return e.sold <= 0 && e.created >= newCutoff; })
          .sort(function (a, b) { return b.created - a.created || a.index - b.index; });

        // 3. The rest — most viewed first (ties keep original order)
        var group3 = entries.filter(function (e) { return e.sold <= 0 && e.created < newCutoff; })
          .sort(function (a, b) { return b.views - a.views || a.index - b.index; });

        group1.concat(group2, group3).forEach(function (e) {
          grid.appendChild(e.el);
        });
      })
      .catch(function () {}); // silently fail — original Shopify order stays
  }

  // Initial page load
  if (isBestSellingActive()) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', reorderGrid);
    } else {
      reorderGrid();
    }
  }

  // After facets.js AJAX sort change: it replaces #ProductGridContainer innerHTML,
  // so we watch for that mutation and re-apply the sort if needed.
  var observer = new MutationObserver(function () {
    if (isBestSellingActive()) {
      // Small delay to ensure the new DOM is fully painted
      setTimeout(reorderGrid, 60);
    }
  });
  observer.observe(gridContainer, { childList: true });
})();
